import React from "react";
import WatchAlertSender from "../components/WatchAlertSender";

export default function MessagesPage() {
  return (
    <div className="bg-white dark:bg-[#1F2A3B] p-4 sm:p-6 rounded-xl shadow-md min-w-0">
      <h3 className="text-base sm:text-lg font-semibold text-gray-700 dark:text-gray-200 mb-4">
        작업자 메시지 / PTT
      </h3>

      <div className="mb-4 rounded-2xl border border-blue-100 bg-blue-50 px-4 py-3 text-sm text-blue-800 dark:border-blue-400/20 dark:bg-blue-400/10 dark:text-blue-200">
        <div className="font-semibold">민트워치 연동 기능</div>
        <div className="mt-1 leading-6">
          작업자 메시지/PTT 기능은 민트워치 단말 연동 시 사용할 수 있습니다.
          민트워치가 연동되지 않은 계정에서는 메시지 전송, PTT, 위치 알림 기능이 제한될 수 있습니다.
        </div>
      </div>

      <div className="min-h-[520px]">
        <WatchAlertSender />
      </div>
    </div>
  );
}